import { IPostPollChoice, IPostPollVotedUser, IPostPoll } from '~/types/community';
import { CurrentUser } from '~/types/';

interface IAddVoterArguments {
  user: false | Partial<CurrentUser>;
  poll: undefined | IPostPoll;
  choiceId: number;
}

export const addVoter = ({ user, poll, choiceId }: IAddVoterArguments) => {
  if (!poll) {
    throw new Error('Poll not found');
  }

  const choice = poll.choices.find(({ id }) => id === choiceId);

  if (!choice) {
    throw new Error('Choice not found');
  }

  const updatedChoice = { ...choice, current_vote: true, votes_count: choice.votes_count + 1 } as IPostPollChoice;

  if (choice.voted_users && user) {
    const { username, warRoomAvatarUrl } = user;
    const voter: IPostPollVotedUser = {
      user_username: username || '',
      war_room_avatar_url: warRoomAvatarUrl,
    };

    const votedUsers: IPostPollVotedUser[] = [voter, ...choice.voted_users];

    if (votedUsers.length > 3) {
      votedUsers.pop();
    }

    updatedChoice.voted_users = votedUsers;
  }

  const pollChoices = [...poll.choices.filter(({ id }) => id !== choiceId), updatedChoice];

  const pollVotesCount = pollChoices.reduce((acc, item) => {
    return acc + item.votes_count;
  }, 0);

  return {
    ...poll,
    votes_count: pollVotesCount,
    choices: pollChoices,
  };
};
